import { render, staticRenderFns } from "./ReportsSidebar.vue?vue&type=template&id=92a28dd6&scoped=true"
import script from "./ReportsSidebar.vue?vue&type=script&lang=js"
export * from "./ReportsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ReportsSidebar.vue?vue&type=style&index=0&id=92a28dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a28dd6",
  null
  
)

export default component.exports